import { Box, Grid, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarList } from '@factorialco/f0-react'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { TrainingRequestDetailFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import ApprovalsInformationBlock from 'modules/approvals/components/ApprovalsInformationBlock'
import { StatusTag } from 'modules/trainings/components/MyTrainings/RequestsComponent/MyRequestsDataTable/StatusTag'

import './index.styles.css'

type Props = {
  trainingRequest: TrainingRequestDetailFragment
  id?: string
}
export const NewProposal = ({ trainingRequest, id }: Props) => {
  const empty = '-'

  const participantAvatars = (trainingRequest.participants ?? []).map((p) => ({
    firstName: p.preferredName || p.firstName,
    lastName: p.lastName,
    src: p.avatar?.url ? buildUrl(p.avatar.url) : undefined,
    type: 'person' as const,
  }))

  const dates = () => {
    if (trainingRequest?.startDate && trainingRequest?.endDate) {
      const start = dateToString(moment(trainingRequest.startDate), 'ui')
      const end = dateToString(moment(trainingRequest.endDate), 'ui')
      return `${start} - ${end}`
    } else {
      return empty
    }
  }
  return (
    <Box gap="s24">
      <Grid variant="small">
        <Box gap="s24">
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.status')}
            </Text>
            <StatusTag status={trainingRequest?.status} />
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.training_type.title')}
            </Text>
            <Text weight="medium" size="300">
              {i18n.t('trainings.training_requests.create.button.new')}
            </Text>
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.training_dates')}
            </Text>
            <Text weight="medium" size="300">
              {dates()}
            </Text>
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.total_training_hours')}
            </Text>
            <Text weight="medium" size="300">
              {trainingRequest?.duration ?? empty}
            </Text>
          </Box>
        </Box>
        <Box gap="s24">
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.request_date')}
            </Text>
            <Text weight="medium" size="300">
              {trainingRequest?.createdAt && dateToString(moment(trainingRequest?.createdAt), 'ui')}
            </Text>
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.training_name')}
            </Text>
            <Text weight="medium" size="300">
              {trainingRequest?.trainingName ?? empty}
            </Text>
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.cost')}
            </Text>
            <Text weight="medium" size="300">
              {trainingRequest?.cost ?? empty}
            </Text>
          </Box>
          <Box gap="s4">
            <Text size="200" color="grey800">
              {i18n.t('trainings.training_requests.my_requests.detail.training_schedule')}
            </Text>
            <Text weight="medium" size="300">
              {trainingRequest?.schedule ?? empty}
            </Text>
          </Box>
        </Box>
      </Grid>
      <Box gap="s4">
        <Text size="200" color="grey800">
          {i18n.t('trainings.training_requests.my_requests.detail.url')}
        </Text>
        <Text size="300">{trainingRequest?.externalReference ?? empty}</Text>
      </Box>
      <Box gap="s4">
        <Text size="200" color="grey800">
          {i18n.t('trainings.training_requests.my_requests.detail.training_need')}
        </Text>
        <Box className="NewProposal_textDisplay">
          <RichTextDisplay content={trainingRequest?.trainingNeed ?? empty} />
        </Box>
      </Box>
      <Box gap="s4">
        <Text size="200" color="grey800">
          {i18n.t('trainings.training_requests.my_requests.detail.additional_information')}
        </Text>
        <Box className="NewProposal_textDisplay">
          <RichTextDisplay content={trainingRequest?.comments ?? empty} />
        </Box>
      </Box>
      {participantAvatars.length > 0 && (
        <Box gap="s4">
          <Text size="200" color="grey800">
            {i18n.t('tasks.approvals.trainings_training_request.fields.participants')}
          </Text>
          <F0AvatarList avatars={participantAvatars} size="md" type="person" max={5} />
        </Box>
      )}
      <Box gap="s4">
        <Text size="300" weight="medium" color="grey800">
          {i18n.t('trainings.training_requests.my_requests.detail.approval_request.title')}
        </Text>
        <Text weight="medium" size="200">
          {i18n.t('trainings.training_requests.my_requests.detail.approval_request.description')}
        </Text>
      </Box>
      <ApprovalsInformationBlock
        resourceId={String(id)}
        resourceType={'Trainings::TrainingRequest'}
      />
    </Box>
  )
}
